import * as machina from "machina";

/**
 * The messageMachine FSM manages the web socket messages that have arrived.
 * If it's in "ready" state, the messages will be forwarded on to any event
 * subscribers (usually a store or store-helper module like outcomeApiOrchestrator).
 * If the FSM is paused, it will buffer any messages that arrive but it won't
 * replay them until it transitions back into "ready" state. The "ignoring"
 * state is present for diagnostics and troubleshooting (in that state, the inbound
 * messages are ignored and discarded, not replayed).
 */

export default new machina.Fsm( {
	namespace: "message-machine",

	initialState: "ready",

	states: {
		ready: {
			pause: "paused",
			ignore: "ignoring",
			message( { data, } ) {
				try {
					const parsed = JSON.parse( data );
					if ( parsed.type ) {
						this.emit( parsed.type, parsed );
					}
				} catch ( e ) {
					console.warn( "Unable to parse message: ", e );
				}
			},
		},
		paused: {
			resume: "ready",
			ignore: "ignoring",
			message() {
				this.deferUntilTransition( "ready" );
			},
		},
		ignoring: {
			resume: "ready",
			pause: "paused",
			message( { data, } ) {
				console.warn( "Ignoring web socket message", data );
			},
		},
	},
} );



// WEBPACK FOOTER //
// ./src/api/socketAPI/messageMachine.js